// Panel administratora: Koszty AI całej aplikacji i limity AI.
export default {
    ai: {
        forbidden: 'Ten panel jest tylko dla administratora.',
        onlyAccount: 'Tylko konto: {account}',
        allAccounts: 'Wszystkie konta',
        unpriced: '{n} wywołanie bez znanej ceny (liczone jako 0) | {n} wywołania bez znanej ceny (liczone jako 0) | {n} wywołań bez znanej ceny (liczone jako 0)',
        errorsShare: 'błędy: {n}%',
        perAccount: 'Koszt na aktywne konto',
        activeAccounts: '{n} aktywne konto | {n} aktywne konta | {n} aktywnych kont',
        avgCall: 'Średnio na wywołanie',
        perDay: 'Koszt dziennie',
        perDayAria: 'Koszt AI dziennie w miesiącu, najwyżej {max} jednego dnia',
        callsN: '{n} wywołanie | {n} wywołania | {n} wywołań',
        limits: {
            title: 'Limity AI',
            hint: 'Miesięczne pułapy kosztu w USD, liczone od 1. dnia miesiąca. Puste pole = bez limitu. Po wyczerpaniu funkcje AI odmawiają do końca miesiąca (administratora to nie dotyczy).',
            app: 'Limit AI aplikacji',
            default: 'Domyślny Limit AI konta',
            none: 'bez limitu',
            appUsed: 'W tym miesiącu: {spent} z {limit}',
            saved: 'Zapisane — działa od razu.',
            failed: 'Nie udało się zapisać.',
        },
        accounts: {
            title: 'Konta',
            hint: 'Koszt w wybranym miesiącu; „teraz" to bieżący miesiąc, względem którego liczy się limit. Kliknij konto, żeby zawęzić widok.',
            hintPast: 'Koszt w wybranym miesiącu; „teraz" to bieżący miesiąc, względem którego liczy się limit.',
            account: 'Konto',
            limit: 'Limit AI',
            now: 'Teraz',
            change: 'Zmień limit',
            filter: 'Pokaż tylko to konto',
            amount: 'Kwota w USD',
            adminNoLimit: 'administrator — bez limitu',
            noLimit: 'bez limitu',
            own: 'własny: {amount}',
            default: 'domyślny: {amount}',
            defaultNone: 'domyślny (bez limitu)',
            modes: {
                default: 'Domyślny',
                custom: 'Własny',
                none: 'Bez limitu',
            },
        },
    },
};
